import { render, staticRenderFns } from "./role.vue?vue&type=template&id=64c14685&scoped=true"
import script from "./role.vue?vue&type=script&lang=ts"
export * from "./role.vue?vue&type=script&lang=ts"
import style0 from "./role.vue?vue&type=style&index=0&id=64c14685&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c14685",
  null
  
)

export default component.exports